import React, { useEffect, useState } from 'react';
import {
  DatePicker, Input, Button, Space,
} from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import moment, { Moment } from 'moment';
import { IoMdRefresh } from 'react-icons/all';
import { Container, Header, HeaderContainer } from './Styled';
import Item from './Item/Item';
import MenuList, { Item as MenuItem } from '../../../system/menuList';
import {
  DialogTranscription,
  TranscriptionFilter,
} from '../../../../model/transcription/types';
import { RootState } from '../../../../model/rootReducer';
import { fillTranscriptionAction } from '../../../../business/actions/dialogTranscriptionActions';
import DateRangePicker from '../../../system/dateRangePicker/DateRangePicker';
import { toDatePicker } from '../../../../helpers/dateFormatHelper';

const { RangePicker } = DatePicker;

type TranscriptionListProps = {
    transcriptions: DialogTranscription[]
    onSelect: (dialogTranscription?: DialogTranscription | null) => void
    selectedDialogTranscriptionId: string | undefined | null
}

const TranscriptionList: React.FunctionComponent<TranscriptionListProps> = (
  props,
) => {
  const dateFormat = 'YYYY-MM-DD';
  const startDate = moment().add(-7, 'days');
  const minDate = moment('2000-01-01');
  const endDate = moment().add(1, 'days');
  const [filter, setFilter] = useState<TranscriptionFilter>({
    phoneNumber: '',
    callId: '',
  });
  const [date, setDate] = useState({
    startDate,
    endDate,
  });

  const selectedBotId = useSelector((state: RootState) => state.bot.selectedBot);
  const pageCount = useSelector(
    (state: RootState) => state.transcription.pageCount,
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (selectedBotId) {
      fillTranscriptions(0);
      props.onSelect(null);
    }
  }, [selectedBotId]);

  useEffect(() => {
    fillTranscriptions(0);
  }, [date]);

  const onIntervalChange = (startDate: Moment, endDate: Moment) => {
    setDate({
      ...date,
      startDate,
      endDate,
    });
  };

  const fillTranscriptions = (page: Number) => {
    let startDate: string;
    if (filter.phoneNumber || filter.callId) {
      startDate = minDate.format(dateFormat);
    } else {
      startDate = date.startDate.format(dateFormat);
    }
    dispatch(fillTranscriptionAction.request({
      page,
      startDate,
      endDate: date.endDate.format(dateFormat),
      filters: filter,
    }));
  };

  const renderHeader = () => (
    <Header>
      <HeaderContainer>
        <DateRangePicker
          startDate={startDate}
          endDate={endDate}
          onChange={onIntervalChange}
        />
        <Button shape="circle" icon={<IoMdRefresh style={{ marginTop: '4px' }} />} onClick={() => fillTranscriptions(0)} />
      </HeaderContainer>
      <Space>
        <Input
          allowClear
          placeholder="Numéro de téléphone"
          onChange={(event) => setFilter({
            ...filter,
            phoneNumber: event.target.value,
          })}
        />
        <Input
          allowClear
          placeholder="ID de l'appel"
          onChange={(event) => setFilter({
            ...filter,
            callId: event.target.value,
          })}
        />
      </Space>
    </Header>
  );

  return (
    <Container>
      <MenuList
        header={renderHeader()}
        size="large"
        onSelect={props.onSelect}
        dataSource={props.transcriptions}
        pageCount={50 * pageCount}
        onLoadMore={(page) => {
          fillTranscriptions(page);
        }}
        renderItem={(dialogTranscription: DialogTranscription) => (
          <MenuItem
            isSelected={
                            dialogTranscription.id === props.selectedDialogTranscriptionId
                        }
            onSelect={() => props.onSelect(dialogTranscription)}
          >
            <Item
              phoneNumber={dialogTranscription.phone}
              duration={dialogTranscription.duration}
              date={dialogTranscription.startDate}
            />
          </MenuItem>
        )}
      />
    </Container>
  );
};

export default TranscriptionList;
